<template>
  <el-select 
    v-model="selectUser" 
    filterable 
    default-first-option 
    placeholder="请输入用户关键字搜索"
    :remote="true"
    :remote-method="userSearch"
    @change="selectChange"
    :loading="loading"
    :clearable="true"
    :multiple="multiple">
      <el-option 
        v-for="item in searchUserList" 
        :key="item.domain_account"
        :label="item.real_name+' '+item.domain_account"
        :value="item.domain_account"
      >
      </el-option>
  </el-select>
</template>
<script>
import httpUrl from "@/static/configUrl"
export default {
  props: {
    value: {
      type: [String, Array],
    },
    multiple: { // 支持多选
      type: Boolean,
      default: false
    }
  },
  watch: {
    value: {
      handler(val) {
        if (this.fromHandleChange) {
          this.fromHandleChange = false
          return
        }
        this.searchUserList = []
        this.selectUser = val
        if (val) {          
          if (this.multiple) {
            this.selectUser.forEach(it => {
              this.fetchUser(it).then(res => {
                this.searchUserList.push(...res)
              })
            })
          } else {
            this.fetchUser(val).then(res => {
              this.searchUserList = res
            })
          }
        }
      },
      immediate: true,
      deep: true,
    },
    selectUser: {
      handler(val) {
        this.$emit('input', val)
      },
      deep: true
    }
  },
  data() {
    return {
      selectUser: undefined,
      searchUserList: [],
      loading: false,
    }
  },
  methods: {
    userSearch(param) {
      if (!param) return
      this.fromHandleChange = true
      this.searchUserList = []
      this.loading = true
      this.fetchUser(param).then(res => {
        this.searchUserList = res
      }).finally(() => {
        this.loading = false
      })
    },
    selectChange() {
      this.fromHandleChange = true
    },
    fetchUser(param) {
      const searchParam = {
        curl: httpUrl.projectUrl + '/project/getAllUserByAssociated',
        param: param
      }
      return new Promise((resolve) => {
        this.$store.dispatch('httpGet', searchParam).then((res) => {
          if (res.flag) {
            resolve(res.data.rows.slice(0, 50))
          }
        })
      })
    },
  }
}
</script>
